export default __webpack_public_path__ + "static/media/days.3bbe6655.svg";